
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-3236f375&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./areaRedpacketActivity.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./areaRedpacketActivity.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-3236f375!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./areaRedpacketActivity.vue"),
  /* scopeId */
  "data-v-3236f375",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/platformManagement/areaRedpacketActivity.vue
// module id = 1543
// module chunks = 3